const pop = (): HTMLElement | null => document.querySelector<HTMLElement>("[data-cv-preview-pop]");
let openFor: string | null = null;
let pending: AbortController | null = null;

function closePreview(): void {
  pending?.abort();
  const box = pop();
  if (box) box.hidden = true;
  openFor = null;
}

function place(box: HTMLElement, button: HTMLElement): void {
  const anchor = button.getBoundingClientRect();
  const left = Math.min(window.innerWidth - box.offsetWidth - 12, Math.max(12, anchor.right - box.offsetWidth));
  let top = anchor.bottom + 6;
  if (top + box.offsetHeight > window.innerHeight - 12) top = Math.max(12, anchor.top - box.offsetHeight - 6);
  box.style.left = `${left}px`;
  box.style.top = `${top}px`;
}

async function openPreview(button: HTMLElement): Promise<void> {
  const box = pop();
  const url = button.dataset.cvPreview;
  if (!box || !url) return;
  if (openFor === url) return closePreview();

  pending?.abort();
  pending = new AbortController();
  openFor = url;
  box.innerHTML = '<div class="sp-rows muted">Loading…</div>';
  box.hidden = false;
  place(box, button);
  try {
    const response = await fetch(url, { headers: { Accept: "text/html" }, signal: pending.signal });
    if (!response.ok) throw new Error(String(response.status));
    box.innerHTML = await response.text();
  } catch (error) {
    if ((error as Error).name === "AbortError") return;
    box.innerHTML = '<div class="sp-rows muted">Couldn\'t load the search preview.</div>';
  }
  if (openFor === url) place(box, button);
}

export function bindCsCampaignPreview(): void {
  document.addEventListener("click", (e) => {
    const target = e.target as HTMLElement;
    const button = target.closest<HTMLElement>("[data-cv-preview]");
    if (button) {
      e.preventDefault();
      openPreview(button);
      return;
    }
    if (!openFor) return;
    if (target.closest("[data-cv-preview-close]") || !target.closest("[data-cv-preview-pop]")) closePreview();
  });
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && openFor) closePreview();
  });
  document.addEventListener("scroll", (e) => {
    if (openFor && !pop()?.contains(e.target as Node)) closePreview();
  }, true);
  document.addEventListener("cs-list:refreshed", closePreview);
  document.addEventListener("turbo:before-cache", closePreview);
}
